import React, { useEffect } from "react";
import { graphql } from "gatsby";
import { Asset } from "../../../../plugins/gatsby-plugin-atollon";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ImageBanner = ({ image }) => {
  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: `.image-banner__inner`,
        start: 'bottom bottom',
        end: 'bottom top',
        scrub: true,
      },
    });

    tl.fromTo(
      `.image-banner__inner .image-banner__wrapper`,
      { yPercent: 0 },
      { yPercent: 35, ease: 'none' }
    );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <section className='image-banner'>
      <div className='image-banner__inner'>
        <div className='image-banner__wrapper'>
          {image && <Asset asset={image} />}
        </div>
      </div>
    </section>
  );
};

export default ImageBanner;

export const query = graphql`
  fragment ImageBannerProps on DatoCmsImageBanner {
    ... on DatoCmsImageBanner {
      id
      image {
        ...InternalAssetProps
      }
    }
  }
`;